import type { ImgHTMLAttributes, ReactElement } from "react";

/** OpenClaw's lobster, served verbatim from their favicon. */
export function OpenClawLogo(
  props: ImgHTMLAttributes<HTMLImageElement>
): ReactElement {
  // eslint-disable-next-line @next/next/no-img-element
  return (
    <img
      src="/brand/openclaw.svg"
      width={16}
      height={16}
      alt=""
      aria-hidden
      {...props}
    />
  );
}
